<template>
    <div
        :class="selected ? 'border-rose' : 'border-black'" 
        class="p-[15px] pr-[30px] flex gap-[10px] border mb-[10px] relative cursor-pointer">
        <label
            :class="selected ? 'bg-rose' : 'bg-black'"
            class="text-[14px] uppercase h-[20px] w-[20px] flex items-center justify-center text-white shrink-0">
            {{ leater }}
        </label>
        <p ref="text" class="transition-all -mt-[3px]">
            {{ answer.text }}
        </p>
    </div>

</template>

<script>
export default {
    name: 'AnswerCard',
    props: {
        leater: String,
        answer: Object,
    },
    computed: {
        selected() {            
            return this.$store.getters.selected == this.answer.type;
        }
    }

}
</script>